module.exports = __webpack_public_path__ + "img/YCP01.ceb275d0.png";